import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Layout } from 'components/layouts';
import { fetchFacilityDashboard } from 'store/metabase/metabase-actions';
import LoadingIndicator from 'components/loading-indicator';
import Box from 'components/box';
import { Alert } from 'components/alerts';
import { formatDate } from 'lib/formatters/date';
import Container from 'components/container';
import { Text } from 'components/text';
import { DatePicker } from 'components/inputs';
import styled from '@emotion/styled';


class FacilityDashboardView extends Component {
  static mapDispatchToProps = dispatch => ({
    loadFacilityDashboard: (startDate, endDate) => dispatch(fetchFacilityDashboard(startDate, endDate)),
  })

  static mapStateToProps = state => ({
    facilityDashboard: state.metabase.facilityDashboard,
    isLoadingFacilityDashboard: state.metabase.isLoadingFacilityDashboard,
    facilityDashboardError: state.metabase.facilityDashboardError,
  })

  constructor(props) {
    super(props);

    this.state = { startDate: null, endDate: null };
  }

  componentDidMount() {
    const { loadFacilityDashboard } = this.props;
    const { startDate, endDate } = this.state;

    loadFacilityDashboard(startDate, endDate);
  }

  handleDateChange = (formattedDate, ethiopianDate, isStart) => {
    if (isStart) {
      this.setState({ startDate: formattedDate }, () => this.fetchStats());
    } else {
      this.setState({ endDate: formattedDate }, () => this.fetchStats());
    }
  }

  fetchStats() {
    const { loadFacilityDashboard } = this.props;
    const { startDate, endDate } = this.state;

    const formattedStartDate = startDate ? startDate.format() : null;
    const formattedEndDate = endDate ? endDate.format() : null;
    loadFacilityDashboard(formattedStartDate, formattedEndDate);
  }

  renderDashboard() {
    const { facilityDashboard, isLoadingFacilityDashboard, facilityDashboardError } = this.props;

    if (isLoadingFacilityDashboard) return <LoadingIndicator noun="Metabase Dashboard" />;

    if (facilityDashboardError) {
      return (
        <Container>
          <Box marginBottom={4}><Alert>{facilityDashboardError}</Alert></Box>
        </Container>
      );
    }

    return (
      <Container>
        <iframe
          // eslint-disable-next-line react/prop-types
          src={facilityDashboard.iframeUrl}
          frameBorder="0"
          width="1000"
          height="500"
          title="Metabase Dashboard"
        />
      </Container>

    );
  }

  render() {
    const { isLoadingFacilityDashboard } = this.props;
    const { startDate, endDate } = this.state;
    let reportHeaderText;

    if (!startDate && !endDate) {
      reportHeaderText = 'Last three months';
    } else {
      reportHeaderText = `${startDate ? formatDate(startDate) : 'Before three months'} to ${endDate ? formatDate(endDate) : 'End Of Time'}`;
    }

    return (
      <Layout pageTitle="Metabase" supportsMobile>
        <DropdownBar>
          <Box flex justifyContent="flex-end" alignItems="center">
            <Box marginRight={4}>
              <DatePicker
                label="Start Date"
                onChange={(formattedDate, rawDate) => this.handleDateChange(formattedDate, rawDate, true)}
                name="start-date"
                disabled={isLoadingFacilityDashboard}
              />
            </Box>
            <Box marginRight={4}>
              <DatePicker
                label="End Date"
                onChange={(formattedDate, rawDate) => this.handleDateChange(formattedDate, rawDate, false)}
                name="end-date"
                disabled={isLoadingFacilityDashboard}
              />
            </Box>
          </Box>
        </DropdownBar>
        <Container>
          <ReportHeader>
            <Text fontSize={6}>{reportHeaderText}</Text>
            <Box marginTop={2}>
              <Text fontSize={2}>Report Period</Text>
            </Box>
          </ReportHeader>
        </Container>
        {this.renderDashboard()}
      </Layout>
    );
  }
}


export default connect(
  FacilityDashboardView.mapStateToProps,
  FacilityDashboardView.mapDispatchToProps,
)(FacilityDashboardView);

FacilityDashboardView.propTypes = {
  loadFacilityDashboard: PropTypes.func.isRequired,
  facilityDashboard: PropTypes.shape({}),
  facilityDashboardError: PropTypes.string.isRequired,
  isLoadingFacilityDashboard: PropTypes.bool.isRequired,
};

FacilityDashboardView.defaultProps = {
  facilityDashboard: {},
};


const DropdownBar = styled.div`
  background-color: ${props => props.theme.colors.gray[0]};
  border-bottom: 1px #f2f2f2 solid;
  padding: 16px;
`;

const ReportHeader = styled.div`
  border-bottom: 1px #f2f2f2 solid;
  padding-top: 16px;
  padding-bottom: 16px;
  margin-left: 16px;
  margin-right: 16px;
`;
